import Service from "../../../Services/index";

const Vendor = {
    namespaced: true,
    state: {
        vendorList: [],
        vendorAll: [],
        vendorForm: {
            first_name: "",
            last_name: "",
            address: "",
            phone: "",
            tax_number: "",
            email: "",
            quotation_file: "",
            quotation_file_1: "",
            quotation_file_2: "",
            quotation_file_3: "",
            quotation_file_4: "",
            company: "",
            remark: "",
            description: "",
        },
        search: {
            keyword: ""
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,

            to: 1
        }
    },
    mutations: {
        SET_VENDOR_LIST: (state, res) => {
            state.vendorList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_VENDOR_ALL: (state, res) => {
            state.vendorAll = res;
        },
        SET_VENDOR_FORM: (state, data) => {
            state.vendorForm = data;
        },
        CLEAR_FORM_DATA: state => {
            state.vendorForm = {
                first_name: "",
                last_name: "",
                address: "",
                phone: "",
                tax_number: "",
                email: "",
                company: "",
                remark: "",
                description: "",
                quotation_file: "",
                quotation_file_1: "",
                quotation_file_2: "",
                quotation_file_3: "",
                quotation_file_4: "",
            };
            state.search = {
                keyword: ""
            }
        },
    },
    actions: {
        setVendors({commit}, page) {
            return Service.vendor.getVendor(page).then(data => {
                commit("SET_VENDOR_LIST", data);
            });
        },
        show({commit}, id) {
            return Service.vendor.showVendor(id).then(response => {
                commit("SET_VENDOR_FORM", response);
            })
        },
        save({commit, state}, id) {
            let formData = {
                first_name: state.vendorForm.first_name,
                last_name: state.vendorForm.last_name,
                address: state.vendorForm.address,
                phone: state.vendorForm.phone,
                tax_number: state.vendorForm.tax_number,
                vendor_id: state.vendorForm.vendor_id,
                company: state.vendorForm.company,
                remark: state.vendorForm.remark,
                description: state.vendorForm.description,
                quotation_file: state.vendorForm.quotation_file,
                quotation_file_1: state.vendorForm.quotation_file_1,
                quotation_file_2: state.vendorForm.quotation_file_2,
                quotation_file_3: state.vendorForm.quotation_file_3,
                quotation_file_4: state.vendorForm.quotation_file_4,
            };
            if (id == null) {//create
                return Service.vendor.createVendor(formData).then(data => {
                    //console.log(data);
                })
            } else {//update
                return Service.vendor.updateVendor(id, formData).then(data => {
                    //console.log(data);
                })
            }
        },
        delete({commit}, id) {
            return Service.vendor.deleteVendor(id).then(() => {
                //console.log('delete success')
            })
        },
        search({commit}, data) {
            return Service.vendor.searchVendor(data).then(res => {
                commit("SET_VENDOR_LIST", res);
            })
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        getVendorAll({commit}) {
            return Service.vendor.getVendorAll().then(res => {
                commit("SET_VENDOR_ALL", res);
            });
        }

    }
};

export default Vendor;
